export const GET_USER_GRIEVANCES_SUCCESS = "GET_USER_GRIEVANCES_SUCCESS";
export const GET_USER_GRIEVANCES_FAILURE = "GET_USER_GRIEVANCES_FAILURE";

export const GET_SINGLE_GRIEVANCE_SUCCESS = "GET_SINGLE_GRIEVANCE_SUCCESS";
export const GET_SINGLE_GRIEVANCE_FAILURE = "GET_SINGLE_GRIEVANCE_FAILURE";

export const CREATE_GRIEVANCE_SUCCESS = "CREATE_GRIEVANCE_SUCCESS";
export const CREATE_GRIEVANCE_FAILURE = "CREATE_GRIEVANCE_FAILURE";

export const UPLOAD_GRIEVANCE_ATTACHMENT_SUCCESS =
  "UPLOAD_GRIEVANCE_ATTACHMENT_SUCCESS";
export const UPLOAD_GRIEVANCE_ATTACHMENT_FAILURE =
  "UPLOAD_GRIEVANCE_ATTACHMENT_FAILURE";
